import { render } from "./CreatorInfo.vue?vue&type=template&id=ef4f7d3c&scoped=true"
import script from "./CreatorInfo.vue?vue&type=script&lang=js"
export * from "./CreatorInfo.vue?vue&type=script&lang=js"

import "./CreatorInfo.vue?vue&type=style&index=0&id=ef4f7d3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2_clean-css@5.3.3_c_e59ecb87855333ab161cabc1a794339b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4f7d3c"]])

export default __exports__